// extracted by mini-css-extract-plugin
export default {"root":"hwCnUaPKjWjngTPabOcw","expanded":"xZqdQMJcQ0wGsei12kER"};